import { render, staticRenderFns } from "./musicPlay.vue?vue&type=template&id=2fcb683e&scoped=true&"
import script from "./musicPlay.vue?vue&type=script&lang=js&"
export * from "./musicPlay.vue?vue&type=script&lang=js&"
import style0 from "./musicPlay.vue?vue&type=style&index=0&id=2fcb683e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb683e",
  null
  
)

export default component.exports